module.exports = __webpack_public_path__ + "img/img_hope02.c61e3e32.jpg";